import HomeHeader from '../../components/home/header/HomeHeader'
import ContactForm from '../../components/contact/ContactForm'
import HomeFooter from '../../components/home/footer/HomeFooter'
import './ContactPage.css'

const ContactPage = () => {
  return (
    <div>
      <div className='header-container'>
        <HomeHeader isHeaderLeft={true} showLoginButton={true} showSignupButton={true}/>
      </div>
      <div style={{ paddingTop: '70px', paddingBottom: '70px' }}>
        {/* put inside the contact page here */}
        <ContactForm/>
      </div>
      <div style={{ background: 'black', color: 'white' }}>
        <HomeFooter />
      </div>
    </div>
  );
}

export default ContactPage;